const testimonials = [
  {
    id: 1,
    text: "Excelente servicio! Reconstruyeron la transmisión de mi Honda y quedó como nueva. Muy profesionales y honestos con los precios.",
    author: "Carlos M.",
    vehicle: "Honda Accord 2018",
    rating: 5,
  },
  {
    id: 2,
    text: "Llevé mi truck diesel y me diagnosticaron el problema rápidamente. El trabajo fue impecable y el precio justo. Muy recomendados!",
    author: "Roberto S.",
    vehicle: "Ford F-250 2019",
    rating: 5,
  },
  {
    id: 3,
    text: "Los mejores mecánicos de Dover! Siempre traigo mis carros aquí. Servicio rápido y de calidad. 100% confiables.",
    author: "María G.",
    vehicle: "Toyota Camry 2020",
    rating: 5,
  },
  {
    id: 4,
    text: "Me salvaron cuando mi BMW empezó a fallar. Diagnóstico preciso y reparación perfecta. Gracias MV Auto Expert!",
    author: "Luis A.",
    vehicle: "BMW 328i 2017",
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section 
      id="testimonials" 
      className="py-20 md:py-32 bg-zinc-900"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span 
            className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-4 block"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Testimonios
          </span>
          <h2 
            className="text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            data-testid="testimonials-title"
          >
            Lo Que Dicen Nuestros Clientes
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="relative bg-zinc-950 border border-zinc-800 p-8 hover:border-blue-600/50 transition-colors"
              data-testid={`testimonial-${testimonial.id}`}
            >
              {/* Quote Mark */}
              <div 
                className="absolute top-4 left-6 text-8xl font-black text-yellow-400/20 leading-none"
                style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              >
                "
              </div>
              
              {/* Content */}
              <div className="relative pt-8">
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>

                {/* Quote */}
                <p className="text-zinc-300 text-lg leading-relaxed mb-6">
                  {testimonial.text}
                </p>

                {/* Author */}
                <div className="border-t border-zinc-800 pt-4">
                  <p 
                    className="text-white font-bold uppercase"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    {testimonial.author}
                  </p>
                  <p className="text-yellow-400 text-sm">
                    {testimonial.vehicle}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
